import { Search, ShieldCheck, HardHat, Activity, FileText } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { DELIVERY_STEPS } from "../../data/siteData";

const icons = {
  search: Search,
  "shield-check": ShieldCheck,
  "hard-hat": HardHat,
  activity: Activity,
  "file-text": FileText,
};

export const HowWeDeliver = () => (
  <section id="process" className="section bg-[#081C3A]" data-testid="process-section">
    <div className="container-custom">
      <SectionHeading
        eyebrow="How We Deliver"
        title="A Clear, Safe, Five-Step Process"
        subtitle="Every Quanticom project follows a structured, safety-led delivery process — from first site visit to final documentation."
        center
      />

      <div className="relative">
        {/* connecting line (desktop) */}
        <div className="hidden lg:block absolute top-[60px] left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-[#00D4FF]/30 to-transparent" />

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {DELIVERY_STEPS.map((s, i) => {
            const Icon = icons[s.icon] || Search;
            return (
              <Reveal key={s.step} delay={i * 0.1}>
                <div className="group relative card-dark rounded-2xl p-6 h-full text-center" data-testid={`delivery-step-${i}`}>
                  <span className="absolute top-4 right-5 text-3xl font-extrabold text-white/5 group-hover:text-[#00D4FF]/20 transition-colors">
                    {s.step}
                  </span>
                  <div className="relative mx-auto w-16 h-16 rounded-2xl flex items-center justify-center bg-[#00D4FF]/10 border border-[#00D4FF]/25 mb-5 group-hover:bg-[#00D4FF] transition-colors duration-300">
                    <Icon className="w-8 h-8 text-[#00D4FF] group-hover:text-[#04121f] transition-colors duration-300" />
                  </div>
                  <h3 className="text-base font-bold text-white mb-2">{s.title}</h3>
                  <p className="text-sm text-slate-400 leading-relaxed">{s.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
